import * as React from "react";

const Automations = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="svg1"
    width="24"
    height="24"
    version="1.1"
    viewBox="0 0 6.35 6.35"
  >
    <g
      id="layer4"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="miter"
      strokeOpacity="1"
      strokeWidth="0.4"
      display="inline"
    >
      <circle
        id="path10"
        cx="1.323"
        cy="1.323"
        r="0.794"
        strokeDasharray="none"
        opacity="1"
      ></circle>
      <circle
        id="path10-6"
        cx="3.175"
        cy="3.175"
        r="0.794"
        strokeDasharray="none"
      ></circle>
      <circle
        id="path10-5"
        cx="5.027"
        cy="5.027"
        r="0.794"
        strokeDasharray="none"
      ></circle>
      <path
        id="path11"
        strokeDasharray="none"
        d="M2.117 1.323h2.26a.915.915 45 0 1 .915.915v.022a.915.915 135 0 1-.915.915h-.408"
        opacity="1"
      ></path>
      <path
        id="path12"
        strokeDasharray="1.2, 0.8"
        strokeDashoffset="2"
        d="M2.381 3.175h-.15a.91.91 135 0 0-.908.908v.036a.91.91 45 0 0 .908.908h1.971"
        opacity="1"
      ></path>
    </g>
  </svg>
);

export default Automations;
